import React, { useState } from "react";
import html2pdf from 'html2pdf.js';
import { FaDownload, FaTimes } from "react-icons/fa";
import "../AdminPrintStyles.css";
import "./OrderDetailModal.css";
import "./UserReportModal.css";

const UserReportModal = ({ type, data, siteSettings, onClose }) => {
    const [downloading, setDownloading] = useState(false);

    const handleDownload = () => {
        const element = document.getElementById('user-report-pdf-content');
        if (!element) return;

        setDownloading(true);
        const isMaster = type === 'all';
        const isMobile = window.innerWidth <= 600;

        const opt = {
            margin: 5,
            filename: isMaster ? `NBitez_User_List_${new Date().toISOString().split('T')[0]}.pdf` : `User_Report_${data.user?.name?.replace(/\s+/g, '_')}.pdf`,
            image: { type: 'jpeg', quality: 1.0 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                logging: false,
                letterRendering: true,
                windowWidth: (isMaster && !isMobile) ? 1400 : 1000, 
                windowHeight: 1600
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: (isMaster && !isMobile) ? 'landscape' : 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        html2pdf().from(element).set(opt).save().then(() => {
            setDownloading(false);
            // Don't close automatically so user can see it's done
        });
    };

    if (!data) return null;

    const isMaster = type === 'all';

    return (
        <div className="modal-overlay pdf-preview-modal">
            <div className={`modal-content ${isMaster ? 'landscape-modal' : ''}`}>
                <div className="modal-header">
                    <h3>
                        {isMaster ? 'NBitez User List Preview' : 'User Report Preview'}
                    </h3>
                    <div className="header-buttons">
                        <button
                            className="btn-download-pdf-modal"
                            onClick={handleDownload}
                            disabled={downloading}
                        >
                            <FaDownload /> {downloading ? 'Downloading...' : 'Download PDF'}
                        </button>
                        <button
                            className="btn-close-modal"
                            onClick={onClose}
                        >
                            <FaTimes /> Close
                        </button>
                    </div>
                </div>

                <div className="preview-modal-body pdf-scroll-wrapper">
                    <div id="user-report-pdf-content" className={`pdf-preview-content ${isMaster ? 'landscape' : ''}`}>
                        {/* Header */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', borderBottom: '4px solid #181c32', paddingBottom: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <img src="/Images/nbitez_logo.jpeg" alt="Logo" style={{ height: '60px', borderRadius: '10px' }} />
                                <h1 style={{ margin: 0, color: '#181c32', fontSize: '28px', fontWeight: '900' }}>nbitez</h1>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ color: '#181c32', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '2px', fontSize: isMaster ? '20px' : '24px' }}>
                                    {isMaster ? 'NBitez User List' : 'User Account Report'}
                                </div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <div style={{ color: '#7e8299', fontSize: '11px' }}>Date: {new Date().toLocaleDateString('en-GB')}</div>
                                {!isMaster && <div style={{ color: '#7e8299', fontSize: '11px' }}>User ID: #{String(data.user?._id || data.user?.id).slice(-10).toUpperCase()}</div>}
                            </div>
                        </div>

                        {/* Content */}
                        {!isMaster ? (
                            <>
                                <div style={{ display: 'flex', gap: '40px', marginBottom: '40px' }}>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ color: '#7e8299', fontSize: '11px', textTransform: 'uppercase', fontWeight: '800', marginBottom: '10px', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>User Profile:</div>
                                        <div style={{ fontSize: '18px', fontWeight: '800', color: '#181c32', marginBottom: '5px' }}>{data.user?.name || "N/A"}</div>
                                        <div style={{ fontSize: '14px', color: '#3f4254', lineHeight: '1.5' }}>Email: {data.user?.email || "N/A"}</div>
                                        <div style={{ fontSize: '14px', color: '#3f4254' }}>Phone: {data.user?.mobile || "N/A"}</div>
                                        <div style={{ fontSize: '14px', color: '#3f4254' }}>Joined: {new Date(data.user?.createdAt).toLocaleDateString('en-GB')}</div>
                                    </div>
                                    <div style={{ width: '200px', backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                                        <div style={{ color: '#7e8299', fontSize: '11px', textTransform: 'uppercase', fontWeight: '800', marginBottom: '5px' }}>Wallet Balance</div>
                                        <div style={{ fontSize: '24px', fontWeight: '900', color: '#181c32' }}>₹{(data.user?.walletBalance || 0).toLocaleString()}</div>
                                        <div style={{ color: '#10b981', fontSize: '11px', fontWeight: '700', marginTop: '5px' }}>{data.user?.isVerified ? 'Verified Account' : 'Standard Account'}</div>
                                    </div>
                                </div>

                                <div style={{ marginBottom: '20px' }}>
                                    <div style={{ color: '#7e8299', fontSize: '11px', textTransform: 'uppercase', fontWeight: '800', marginBottom: '10px', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Order History Summary:</div>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #181c32' }}>
                                                <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', color: '#181c32' }}>ORDER ID</th>
                                                <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', color: '#181c32' }}>DATE</th>
                                                <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', color: '#181c32' }}>METHOD</th>
                                                <th style={{ padding: '12px', textAlign: 'right', fontSize: '12px', color: '#181c32' }}>AMOUNT</th>
                                                <th style={{ padding: '12px', textAlign: 'center', fontSize: '12px', color: '#181c32' }}>STATUS</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.orders && data.orders.length > 0 ? data.orders.map(order => (
                                                <tr key={order._id || order.id} style={{ borderBottom: '1px solid #f1f1f1' }}>
                                                    <td style={{ padding: '12px', fontSize: '12px', color: '#181c32', fontWeight: '600' }}>#{String(order._id || order.id).slice(-8).toUpperCase()}</td>
                                                    <td style={{ padding: '12px', fontSize: '12px', color: '#3f4254' }}>{new Date(order.createdAt).toLocaleDateString('en-GB')}</td>
                                                    <td style={{ padding: '12px', fontSize: '12px', color: '#3f4254' }}>{order.paymentMethod || "N/A"}</td>
                                                    <td style={{ padding: '12px', fontSize: '12px', textAlign: 'right', fontWeight: '700', color: '#181c32' }}>₹{(order.totalPrice || order.totalAmount || 0).toLocaleString()}</td>
                                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                                        <span style={{ fontSize: '10px', padding: '4px 8px', borderRadius: '4px', backgroundColor: '#e1f0ff', color: '#0095e8', fontWeight: '700', textTransform: 'uppercase' }}>
                                                            {order.status || "Pending"}
                                                        </span>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr><td colSpan="5" style={{ padding: '30px', textAlign: 'center', color: '#7e8299', fontSize: '13px' }}>No orders found.</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        ) : (
                            <div className="master-report-container">
                                <table className="master-list-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #181c32' }}>
                                            <th style={{ padding: '10px', textAlign: 'left', color: '#181c32' }}>NAME</th>
                                            <th style={{ padding: '10px', textAlign: 'left', color: '#181c32' }}>EMAIL</th>
                                            <th style={{ padding: '10px', textAlign: 'left', color: '#181c32' }}>MOBILE</th>
                                            <th style={{ padding: '10px', textAlign: 'left', color: '#181c32' }}>ROLE</th>
                                            <th style={{ padding: '10px', textAlign: 'left', color: '#181c32' }}>JOIN DATE</th>
                                            <th style={{ padding: '10px', textAlign: 'center', color: '#181c32' }}>STATUS</th>
                                            <th style={{ padding: '10px', textAlign: 'right', color: '#181c32' }}>WALLET</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map(user => (
                                            <tr key={user._id || user.id} className="master-list-row" style={{ borderBottom: '1px solid #f1f1f1' }}>
                                                <td data-label="NAME" style={{ padding: '10px', color: '#181c32', fontWeight: '600' }}>{user.name || "N/A"}</td>
                                                <td data-label="EMAIL" style={{ padding: '10px', color: '#3f4254' }}>{user.email || "-"}</td>
                                                <td data-label="MOBILE" style={{ padding: '10px', color: '#3f4254' }}>{user.mobile || "-"}</td>
                                                <td data-label="ROLE" style={{ padding: '10px', color: '#3f4254' }}><span style={{ padding: '2px 6px', backgroundColor: '#f1faff', color: '#0095e8', borderRadius: '4px' }}>{user.role || "User"}</span></td>
                                                <td data-label="JOIN DATE" style={{ padding: '10px', color: '#3f4254' }}>{user.createdAt ? new Date(user.createdAt).toLocaleDateString('en-GB') : "N/A"}</td>
                                                <td data-label="STATUS" style={{ padding: '10px', textAlign: 'center' }}>
                                                    <span style={{ fontSize: '9px', padding: '3px 6px', borderRadius: '4px', backgroundColor: user.isVerified !== false ? '#e1f0ff' : '#fff5f8', color: user.isVerified !== false ? '#0095e8' : '#f1416c', fontWeight: '700' }}>
                                                        {user.isVerified !== false ? 'ACTIVE' : 'INACTIVE'}
                                                    </span>
                                                </td>
                                                <td data-label="WALLET" style={{ padding: '10px', textAlign: 'right', fontWeight: '700', color: '#181c32' }}>₹{(user.walletBalance || 0).toLocaleString()}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Footer */}
                        <div style={{ marginTop: '40px', borderTop: '1px solid #eff2f5', paddingTop: '20px', textAlign: 'center' }}>
                            <div style={{ fontSize: '13px', fontWeight: '700', color: '#181c32', marginBottom: '8px' }}>Nbitez Premium Admin Panel - User Report</div>
                            <div style={{ fontSize: '11px', color: '#7e8299' }}>This is a system generated report. For any discrepancies, please contact support.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserReportModal;
